import styled from '@emotion/styled';

export type ModalShellSize = 'sm' | 'md' | 'lg' | 'xl';

const SIZE_MAX_WIDTH: Record<ModalShellSize, string> = {
    sm: '440px',
    md: '560px',
    lg: '720px',
    xl: '1040px',
};

export const ModalShell = styled.div<{ size?: ModalShellSize }>`
    position: relative;
    width: ${({ size = 'md' }) => `min(${SIZE_MAX_WIDTH[size]}, calc(100vw - 32px))`};
    max-width: ${({ size = 'md' }) => SIZE_MAX_WIDTH[size]};
    max-height: calc(100vh - 32px);
    margin: auto;
    display: flex;
    flex-direction: column;
    padding: 32px 24px 24px;
    border: 1px solid rgba(131, 83, 226, 0.08);
    border-radius: 28px;
    background:
        radial-gradient(circle at top right, rgba(131, 83, 226, 0.12), transparent 34%),
        linear-gradient(180deg, #ffffff 0%, #fcfbff 100%);
    box-shadow:
        0 18px 44px rgba(15, 23, 42, 0.08),
        0 2px 10px rgba(15, 23, 42, 0.04);
    overflow: hidden;

    @media (max-width: 640px) {
        padding: 24px 18px 18px;
        border-radius: 24px;
    }
`;

export default ModalShell;
